























































































































































import Vue from 'vue';

export default Vue.extend({
    name: 'App',
    methods: {
        logout() {
            this.$store.dispatch('logout')
        }
    },
    computed: {
        background() {
            return require('./assets/background-topo.jpg');
        },
        usuario() {
            return this.$store.state.usuario
        }
    },
});
